const defaultState = {
  requesting: false,
  error: false,
  result: null,
  isCreate: false,
  isDelete: false
}

export default function counter(state = defaultState, action) {
  switch (action.type) {
    case 'UPDATE_FACTORS_REQUESTED':
      return {
        requesting: true,
        error: false,
        result: null,
        isCreate: true,
        isDelete: false
      }
    case 'UPDATE_FACTORS_SUCCEEDED':
      return {
        requesting: false,
        error: false,
        result: action.payload,
        isCreate: true,
        isDelete: false
      }
    case 'UPDATE_FACTORS_FAILED':
      return {
        requesting: false,
        error: true,
        result: action.payload,
        isCreate: true,
        isDelete: false
      }
    default:
      return state
  }
}
